import { Component, Input, EventEmitter, Output } from '@angular/core';

import { HisAuthService, HisNotificationService, HisUiService } from 'hisng';

import { DEFAULT_CONTEXT } from 'app/fs/res/common/model/constants';
import { ResearchPartnerSimple, ResearchPartner } from 'app/fs/res/common/model/researchPartner/researchPartner';

@Component( {
    selector: 'res-external-organization-edit',
    templateUrl: './external-organization-edit.component.html',
} )
export class ExternalOrganizationEditComponent {
    @Input() organizations: ResearchPartnerSimple[]; // ngModel
    @Input() isAddOrganization: boolean;
    @Input() showCreateLink = true;
    @Input() newResearchPartner: ResearchPartner;
    @Input() isCreateInline = false;
    @Input() showSelectionBelow = true;
    @Input() singleSelect = true;
    @Input() clearAfterSelection = false;
    @Input() readonly = false;

    @Input() hisDdContexts: string[] = [ DEFAULT_CONTEXT ];
    @Input() set ddKey( ddKey: string ) {
        if ( ddKey ) {      
            this._ddKey = ddKey;
        }
    }

    @Output() selectedExternalOrgUnitChange: EventEmitter<ResearchPartnerSimple[]> = new EventEmitter();
    @Output() deleteExternalOrgUnitChange: EventEmitter<ResearchPartnerSimple> = new EventEmitter();
    @Output() createExternalOrgUnitChange: EventEmitter<void> = new EventEmitter();

    public _ddKey = 'fs.res.common.organizations.external';
    public isCreateInlineActive = false;
    public selectedOrganization: ResearchPartnerSimple;

    constructor( public auth: HisAuthService,
        public hisUiService: HisUiService,
        private notificationService: HisNotificationService ) {
    }

    /* implementation of <p-autoComplete> to set organization */
    public onSelect( event: ResearchPartnerSimple ) {
        let researchPartner: ResearchPartnerSimple = event;
        if ( this.organizations.find( o => o.id === researchPartner.id ) ) {
            this.notificationService.warnI18nRes( 'fs.res.common.organizations.alreadyAssigned' );
            // bei Warnmeldung das input-Feld nicht löschen, damit man noch weiss worum es ging
        } else {
            this.organizations.push( researchPartner );
            this.selectedExternalOrgUnitChange.emit( this.organizations );
            if ( this.singleSelect ) {
                this.isAddOrganization = false;
            }
            // Input-Feld löschen
            // #296767 timeout scheint notwendig, damit des Eingabefeld auch bei der 2. und 3. Auswahl wieder gelöscht wird...
            if (this.clearAfterSelection) {
                setTimeout(() => {
                    this.selectedOrganization = null;
                    return;
                });
            }
        }
    }

    /* delete external organization from table */
    public deleteOrganization( row: ResearchPartnerSimple ): void {
        this.selectedOrganization = null;
        this.deleteExternalOrgUnitChange.emit( row );
    }

    /* create new ResearchPartner (external organization unit) */
    public createExternalOrgUnit() {
        if ( this.isCreateInline ) {
            this.isCreateInlineActive = true;
        } else {
            this.createExternalOrgUnitChange.emit();
        }
    }

    public backToSelectExternalOrgaUnit() {
        this.newResearchPartner.business = null;
        this.isCreateInlineActive = false;
    }

}
